import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import { registerQuery } from 'data-fetching-client';
/*
 * NOTE: This endpoint will hit Salesforce under the covers via a call to:
 * `quoteClient.findApprovedApolloQuotesByHubId(hubId)`, only when there are valid
 * approved quotes for this hub. This endpoint should be hit sparingly as
 * our Salesforce API integration has rate limiting.
 *
 * Context: https://git.hubteam.com/HubSpotProtected/UpgradeCatalog/issues/230#issuecomment-464922
 *
 */
export const GET_ACTIVE_QUOTES = registerQuery({
  fieldName: 'activeQuotes',
  args: ['apiUrl', 'portalId'],
  fetcher() {
    const apiUrl = getFullUrl('app-api', {
      hubletOverride: na1
    });
    const url = `${apiUrl}/quotes/v1/quotes/approved/hub/${PortalIdParser.get()}`;
    return http.get(url);
  }
});